import { render, staticRenderFns } from "./CheckListForm.vue?vue&type=template&id=54de89cd&scoped=true"
import script from "./CheckListForm.vue?vue&type=script&lang=js"
export * from "./CheckListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54de89cd",
  null
  
)

export default component.exports